export enum ContextMenuAction {
  ChangeLanguage = 'ChangeLanguage',
  ChangeLanguageOption = 'ChangeLanguageOption',
  OpenDashboard = 'OpenDashboard',
  SignOut = 'SignOut',
  ViewCredentials = 'ViewCredentials',
  ViewCredentialsOption = 'ViewCredentialsOption',
}
